import { PaymentProcessorEnum } from '@systemeio/ui'
import { PaystackPaymentProcessor } from 'modules/profile/payment-gateways/integrations/paystack/types'

export const paystackPaymentProcessors: PaystackPaymentProcessor[] = [
  PaymentProcessorEnum.PaystackCI,
  PaymentProcessorEnum.PaystackEG,
  PaymentProcessorEnum.PaystackGH,
  PaymentProcessorEnum.PaystackKE,
  PaymentProcessorEnum.PaystackNG,
  PaymentProcessorEnum.PaystackZA,
]
